import styled from 'styled-components';
import Button from '../Button';
import { FaUserCircle } from 'react-icons/fa';

import { primaryColor, outlineGray, textGrey, primaryColorStrong } from '../../config/colors';

export const Wrapper = styled.header`
  display: flex;
  flex-direction: column;
  border-bottom: solid ${outlineGray} 1px;
  padding: 25px 40px 10px 40px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center
  flex-direction: row;
  max-height: 130px;
  padding-bottom: 20px;
`;

export const TitlesWrapper = styled.div`
  flex: 1;
`;

export const LogoAndTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
`;

export const MainTitle = styled.h2`
  margin-top: 0px;
  margin-left: 40px;
`;

export const Logo = styled.img`
  width: 90px;
  height: 50px;
`;

export const CastLogo = styled.img`
  height: 84px;
  margin: -16px 0px;
`;

export const UserAreaWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: start;
  justify-content: flex-end;
`;

export const UserWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const LogoutButton = styled(Button).attrs({
  wrapperStyle: {
    marginRight: '15px',
  },
  textStyle: {
    color: 'red',
    fontSize: '0.75rem',
    fontWeight: '600',
  },
})``;

export const Username = styled.p`
  color: ${textGrey};
  font-size: 0.75rem;
  font-weight: 800;
  margin-right: 10px;
`;

export const UserImagePlaceholder = styled(FaUserCircle)`
  color: ${primaryColor};
  align-self: center;
  width: 60px;
  height: 60px;
`;

export const UserOptionsList = styled('ul')`
  margin: 0px;
  padding: 0px;
  margin-block: 5px;
  box-sizing: border-box;
  font-size: 0.875rem;
`;

export const UserOption = styled('li')`
  list-style: none;
  padding-inline: 5px;
  padding-block: 3px;
  border-bottom: 1px solid ${textGrey};
  &:hover {
    background-color: ${primaryColorStrong};
    color: white;
    cursor: pointer;
    border-bottom: 1px solid ${primaryColor};
  }
  &:last-of-type {
    border-bottom: 0px;
    &:hover {
      border-bottom: 0px;
    }
  }
`;
